import { useMemo } from "react";
import clsx from "clsx";

import GridCard from "components/GridCard";
import { TRUCK_ITEMS } from "constants/trucks";
import { useColorScheme } from "hooks/useColorScheme";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import styles from "./style.module.scss";

export default function TruckManage() {
  const { currentIsDark } = useColorScheme();
  const { isTruckSearchRole, isShipper } = useUserFeature();

  const selectedData = useMemo(() => {
    let items = TRUCK_ITEMS ?? [];
    if (!isTruckSearchRole) {
      items = items.filter((pay) => pay.label !== "Truck Search");
    }
    if (isShipper) {
      items = items.filter((pay) => pay.label !== "Post Truck" && pay.label !== "My Trucks");
    }

    return items;
  }, [isTruckSearchRole, isShipper]);

  return selectedData ? (
    <MainLayout title="Trucks" className="ml-4 mr-5">
      <div
        className={clsx(styles.truckGrid, !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]")}>
        {selectedData?.map((item) => <GridCard key={item.id} item={item} />)}
      </div>
    </MainLayout>
  ) : null;
}
